import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { RegionDomain } from '../domains/region.domain';
import { di } from '../state/inversify.config';
import { RegionType } from '../state/reduxRepositories/region/region.enum';
import { regionConfig } from '../state/regionConfig';
import { AlertDialog } from '../components/alertDialog/alertDialog';

export const RegionChecking = () => {
  const { t } = useTranslation();
  const regionDomain = di.get<RegionDomain>(RegionDomain);
  const currentRegion = regionDomain.useRegionSelector();
  const localRegion = regionDomain.useSiteRegion();
  const fromRegion = regionDomain.useLocalRegion(currentRegion?.country);
  const supportedRegion = regionDomain.useSupportedRegions();
  const isRegionSupported = regionDomain.useIsSupportedRegion(
    currentRegion?.country,
  );
  const getOtherRegion = supportedRegion.find((r: string) => r !== localRegion);
  const otherRegion = RegionType[getOtherRegion as keyof typeof RegionType];
  const otherRegionLink =
    regionConfig[getOtherRegion as keyof typeof RegionType];

  const [open, setOpen] = useState(true);

  const onDismiss = () => {
    regionDomain.dispatchDialog(false);
  };

  const onConfirm = () => {
    regionDomain.dispatchDialog(false);
    window.location.href = otherRegionLink;
  };

  return (
    <>
      {isRegionSupported ? (
        <AlertDialog
          actions
          title={t('REGION_VALIDATION_HEADER')}
          content={t('REGION_VALIDATION_MESSAGE', {
            siteRegion: localRegion,
            currentRegion: fromRegion,
          })}
          open={open}
          setOpen={setOpen}
          onConfirm={onConfirm}
          onDismiss={onDismiss}
          confirmLabel={t('CONFIRM')}
          cancelLabel={t('CANCEL')}
        />
      ) : (
        <AlertDialog
          title={t('REGION_VALIDATION_HEADER')}
          content={
            <div>
              <Trans
                i18nKey="INVALID_REGION_MESSAGE"
                values={{
                  siteRegion: localRegion,
                  currentRegion: fromRegion,
                  otherRegion,
                  otherRegionLink,
                }}
              >
                <a href={otherRegionLink}>{otherRegionLink}</a>
              </Trans>
            </div>
          }
          open={open}
          setOpen={setOpen}
          onDismiss={onDismiss}
        />
      )}
    </>
  );
};
